const escapeHTML = (str) => {
    const escapedHTML = str
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
    return escapedHTML;
};

export default escapeHTML;
